import { Injectable } from '@angular/core';
import { LabStore } from './state/lab-store';
import { LabQuery } from './state/lab-query';
import { LabCasesState } from '@shared/enums';

@Injectable({
	providedIn: 'root',
})
export class LabService {
	constructor(private store: LabStore, private query: LabQuery) {}

	reset(): void {
		this.store.reset();
	}

	getSelectedCasesState(): LabCasesState {
		return this.query.selectedCasesState;
	}

	updateSelectedCasesState(casesState: LabCasesState): void {
		this.store.update((state) => {
			state.selectedCasesState = casesState;
		});
	}
}
